import React, { useEffect, useRef, useState } from "react";
import "../ShareView.css"
import { useSelector } from "react-redux";
import axios from "axios";
import { Button } from "primereact/button";


const ONE_DAY_MS = 24 * 60 * 60 * 1000;

function isOneDayPassed(timestamp) {
	return Date.now() - timestamp >= ONE_DAY_MS;
}

const ShareView = () => {
	//clientID
	const { num } = useSelector((state) => state.AuthReducer);
	const [peer, setPeer] = useState(null);
	const [localStream, setLocalStream] = useState(null);
	let dataConnections = []; // 연결된 데이터 채널 목록 (Host용)
	let myDataConnection = null; // 호스트와 연결된 데이터 채널 (Viewer용)
	let receivedBuffers;
	const localStreamRef = useRef(null);
	const [rows, setRows] = useState([]);

	const callsRef = useRef([]);
	const peerRef = useRef(null);



	const shareviewList = async () => {
		const url = `/api/member/shareview_list.json`;
		const { data } = await axios.get(url);

		let arr = [];
		if (data.result.length > 0) {
			for (const item of data.result) {
				if (isOneDayPassed(item.timestamp)) {
					const url1 = `/api/member/shareview_delete.json?cid=${item.cid}`;
					await axios.delete(url1);
				}
				else {
					if (num !== item.cid) {
						arr.push({ 'cid': item.cid })
					}
				}
			}
			setRows(arr);
		}
	}

	useEffect(() => {
		shareviewList();
	}, []);

	useEffect(() => {
		if (num !== 0) {
			initializePeer(num);
		}
		return () => {
			if (peerRef.current) {
				console.log("Destroying peer:", peerRef.current.id);
				peerRef.current.destroy();
				peerRef.current = null;
			}
		};
	}, [num]);




	// PeerJS 초기화 및 ID 설정 함수
	function initializePeer(customId) {
		let peer;

		// 이미 연결된 상태라면 초기화 방지
		if (peer && !peer.disconnected && !peer.destroyed) {
			return;
		}

		if (peerRef.current) {
			peerRef.current.destroy();
			peerRef.current = null;
		}

		// ID가 입력되면 해당 ID로, 없으면 랜덤으로 생성 Peer 생성 옵션
		let options = {
			host: '114.207.245.181',         // 현재 접속한 IP (예: 192.168.0.10)
			port: 19000,                     // server.js에서 설정한 PeerJS 포트
			path: '/peerjs',
			debug: 2
		};

		if (customId) {
			peer = new window.Peer(customId, options);
		} else {
			peer = new window.Peer(options); // 랜덤 ID
		}


		// PeerJS 서버 연결 성공 시
		peer.on('open', (id) => {
			
		});


		peer.on('call', (call) => {
			callsRef.current.push(call);

			if (localStreamRef.current) {
				call.answer(localStreamRef.current);
			} else {
				call.answer();
			}
		});



		// 데이터 채널 연결 요청 (Viewer -> Host)
		peer.on('connection', (conn) => {
			console.log("Incoming data connection from:", conn.peer);

			conn.on('open', () => {
				console.log("Data connection established with:", conn.peer);
				conn.send({ type: 'chat', sender: 'System', message: '파일 전송 가능' });
			});

			conn.on('data', (data) => {
				handleIncomingData(data);
			});

			conn.on('close', () => {
				console.log("Data connection closed:", conn.peer);
			});
		});


		// 에러 처리
		peer.on('error', (err) => {
			console.error('PeerJS Error:', err);

			if (err.type === 'unavailable-id') {
				alert("이미 사용 중인 ID입니다. 다른 ID를 입력해주세요.");
				peer = null;
			} else {
				alert('연결 에러 발생: ' + err.type);
			}
		});

		peerRef.current = peer;
		setPeer(peer);
	}


	// 1. Host: 화면 공유 시작 함수
	async function startScreenShare() {
		try {
			const videoElement = document.getElementById('screen-preview');

			// 화면 공유 스트림 요청 (오디오 포함)
			const localStream = await navigator.mediaDevices.getDisplayMedia({
				video: { cursor: "always" },
				audio: true // 시스템 오디오 공유 활성화
			});

			localStreamRef.current = localStream;
			setLocalStream(localStream);

			callsRef.current.forEach(call => {
				const sender = call.peerConnection
					.getSenders()
					.find(s => s.track && s.track.kind === "video");

				if (sender) {
					sender.replaceTrack(localStream.getVideoTracks()[0]);
				}
			});

			// 내 화면 미리보기
			videoElement.srcObject = localStream;
			videoElement.muted = true; // 내 화면은 소리 끔

			// 화면 공유 중지 시 처리
			localStream.getVideoTracks()[0].onended = () => {
				console.log('화면 공유가 중단되었습니다.');
				videoElement.srcObject = null;
				setLocalStream(null);
			};
			// setLocalStream(localStream);
			console.log("화면 공유 시작됨. 다른 사용자가 내 ID로 연결하면 이 화면을 볼 수 있습니다.");

		} catch (err) {
			console.error("화면 공유 시작 실패:", err);
		}
	}


	// 2. Viewer: 친구에게 연결하여 화면 보기
	function connectToPeer(friendId) {
		console.log(`Connecting to ${friendId}...`);

		// 연결 시도 시 바로 전체화면으로 진입 (브라우저 정책상 사용자 클릭 시점에 요청해야 함)
		// 스트림이 아직 안 왔더라도 검은 화면(또는 로딩)으로 전체화면 진입
		const videoContainer = document.getElementById('video-container');
		const exitBtn = document.getElementById('exit-fullscreen-btn');
		if (!document.fullscreenElement) {
			videoContainer.requestFullscreen().then(() => {
				exitBtn.style.display = 'block';
			}).catch(err => {
				console.warn("Auto-fullscreen failed:", err);
			});
		}

		// 친구에게 전화를 겁니다. (null 대신 dummy stream 사용)
		const canvas = document.createElement('canvas');
		canvas.width = 1;
		canvas.height = 1;
		const dummyStream = canvas.captureStream();

		// peer.call이 유효한 스트림을 기대하므로 dummyStream 전달
		const call = peer.call(friendId, dummyStream);
		console.log(call);

		if (!call) {
			console.error("Failed to initiate call. 'call' object is undefined.");
			alert("연결 시도에 실패했습니다. PeerJS 상태를 확인해주세요.");
			return;
		}

		call.on('stream', (remoteStream) => {
			console.log("Received remote stream!");
			const videoElement = document.getElementById('screen-preview');
			videoElement.srcObject = remoteStream;
			videoElement.muted = false; // 상대방 소리는 들어야 함
			videoElement.play().catch(e => console.error("Autoplay failed:", e));
		});

		call.on('close', () => {
			console.log("연결이 종료되었습니다.");
			document.getElementById('screen-preview').srcObject = null;
			// 연결 끊기면 전체화면도 나가기
			if (document.fullscreenElement) {
				document.exitFullscreen();
			}
		});

		call.on('error', (err) => {
			console.error("Call error:", err);
			alert("연결 중 오류가 발생했습니다.");
		});

		// 데이터 채널 연결 (채팅/참여자용)
		const conn = peer.connect(friendId);
		conn.on('open', () => {
			console.log("Connected to Host Data Channel");
			myDataConnection = conn;

			// 내 ID 전송 (참여자 목록 등록용)
			conn.send({ type: 'join', id: peer.id });
		});

		conn.on('data', (data) => {
			handleIncomingData(data);
		});

		conn.on('error', (err) => {
			console.error("Data connection error:", err);
		});
	}

	// 3. Utils: 전체화면 토글
	function toggleFullScreen() {
		const videoContainer = document.getElementById('video-container');
		const exitBtn = document.getElementById('exit-fullscreen-btn');
		// const videoElement = document.getElementById('screen-preview'); 
		// 스트림 유무와 상관없이 UI 컨테이너를 전체화면 처리할 수 있도록 제한 해제

		if (!document.fullscreenElement) {
			videoContainer.requestFullscreen().then(() => {
				exitBtn.style.display = 'block'; // 전체화면 때 버튼 보이기
			}).catch(err => {
				alert(`전체화면 모드 전환 실패: ${err.message}`);
			});
		} else {
			document.exitFullscreen().then(() => {
				exitBtn.style.display = 'none'; // 전체화면 종료 시 버튼 숨기기
			});
		}
	}

	// 전체화면 상태 감지 (Esc키로 나갔을 때도 버튼 숨기기 위함)
	document.addEventListener('fullscreenchange', () => {
		const exitBtn = document.getElementById('exit-fullscreen-btn');
		if (!document.fullscreenElement) {
			exitBtn.style.display = 'none';
		} else {
			exitBtn.style.display = 'block';
		}
	});

	// 데이터 수신 처리
	function handleIncomingData(data) {
		if (data.type === 'chat') {
			appendChatMessage(data.sender, data.message);

			// Host라면 다른 모든 Viewer에게 브로드캐스트 (Echo)
			if (dataConnections.length > 0) {
				broadcastData(data);
			}
		}
	}

	// 데이터 브로드캐스트 (Host -> All Viewers)
	function broadcastData(data) {
		dataConnections.forEach(conn => {
			// 보낸 사람에게는 다시 보내지 않음 (선택 사항)
			if (conn.open) {
				conn.send(data);
			}
		});
	}


	// 메시지 전송
	function sendChatMessage() {
		const input = document.getElementById('chat-input');
		const message = input.value.trim();
		if (!message) return;

		const myId = peer ? peer.id : 'Me';

		// 내 화면에 표시
		appendChatMessage('Me', message);

		const data = { type: 'chat', sender: myId, message: message };

		// Viewer -> Host 전송
		if (myDataConnection && myDataConnection.open) {
			myDataConnection.send(data);
		}
		// Host -> All Viewers 전송
		else if (dataConnections.length > 0) {
			broadcastData(data);
		}

		input.value = '';
	}

	// UI: 채팅 메시지 추가
	function appendChatMessage(sender, message) {
		const chatBox = document.getElementById('chat-messages');
		if (!chatBox) return; // UI 아직 없으면 무시

		const div = document.createElement('div');
		div.innerHTML = `<strong>${sender}:</strong> ${message}`;
		div.style.marginBottom = "5px";
		div.style.fontSize = "13px";
		chatBox.appendChild(div);
		chatBox.scrollTop = chatBox.scrollHeight;
	}

	// UI: 참여자 목록 업데이트 (Host Only for now)
	function updateParticipantList() {
		const listEl = document.getElementById('participant-list');
		if (!listEl) return;

		listEl.innerHTML = '';
		dataConnections.forEach(conn => {
			const li = document.createElement('li');
			li.innerText = conn.peer;
			listEl.appendChild(li);
		});
	}


	/////////////////////////////////
	// 5. File Sharing Logic
	function setupDragAndDrop() {
		const chatSection = document.querySelector('.chat-section');
		const dropZone = document.getElementById('drop-zone');
		// Drag Enter/Over
		chatSection.addEventListener('dragover', (e) => {
			e.preventDefault();
			chatSection.classList.add('drag-over');
		});
		chatSection.addEventListener('dragenter', (e) => {
			e.preventDefault();
			chatSection.classList.add('drag-over');
		});
		// Drag Leave
		chatSection.addEventListener('dragleave', (e) => {
			e.preventDefault();
			// 자식 요소로 들어갔을 때 깜빡임 방지용 로직이 필요할 수 있으나 간단히 처리
			if (e.target === chatSection || e.target === dropZone) {
				chatSection.classList.remove('drag-over');
			}
		});
		// Drop
		chatSection.addEventListener('drop', (e) => {
			e.preventDefault();
			chatSection.classList.remove('drag-over');
			const files = e.dataTransfer.files;
			if (files.length > 0) {
				sendFile(files[0]);
			}
		});
	}


	const CHUNK_SIZE = 16384; // 16KB
	async function sendFile(file) {
		const myId = peer ? peer.id : 'Me';
		appendChatMessage('System', `Sending file: ${file.name} (${formatBytes(file.size)})...`);
		// 1. Send File Metadata
		const metaData = {
			type: 'file-start',
			sender: myId,
			meta: {
				name: file.name,
				size: file.size,
				type: file.type
			}
		};
		broadcastOrSend(metaData);
		// 2. Read and Send Chunks
		const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
		let offset = 0;
		for (let i = 0; i < totalChunks; i++) {
			const slice = file.slice(offset, offset + CHUNK_SIZE);
			const buffer = await slice.arrayBuffer();
			const chunkData = {
				type: 'file-chunk',
				sender: myId,
				payload: buffer // ArrayBuffer works with PeerJS BinaryPack
			};
			broadcastOrSend(chunkData);
			offset += CHUNK_SIZE;
			// 간단한 흐름 제어 (너무 빠르면 끊길 수 있음 -> await sleep?)
			if (i % 100 === 0) await new Promise(r => setTimeout(r, 10));
		}
		// 3. Send End Signal
		const endData = {
			type: 'file-end',
			sender: myId
		};
		broadcastOrSend(endData);
		appendChatMessage('System', `File sent successfully.`);
	}

	function broadcastOrSend(data) {
		// Viewer -> Host
		if (myDataConnection && myDataConnection.open) {
			myDataConnection.send(data);
		}
		// Host -> All Viewers
		else if (dataConnections.length > 0) {
			broadcastData(data);
		}
	}

	// 수신 처리
	function handleFileStart(sender, meta) {
		console.log(`Receiving file from ${sender}: ${meta.name}`);
		receivedBuffers[sender] = {
			meta: meta,
			chunks: [],
			receivedSize: 0
		};
		appendChatMessage(sender, `Started sharing file: <strong>${meta.name}</strong>`);
	}


	function handleFileChunk(sender, buffer) {
		const context = receivedBuffers[sender];
		if (!context) return;
		context.chunks.push(buffer);
		context.receivedSize += buffer.byteLength;
	}



	function handleFileEnd(sender) {
		const context = receivedBuffers[sender];
		if (!context) return;
		const blob = new Blob(context.chunks, { type: context.meta.type });
		const url = URL.createObjectURL(blob);
		const downloadLink = `<a href="${url}" download="${context.meta.name}" style="color: #4f46e5; text-decoration: underline;">💾 Download ${context.meta.name}</a> (${formatBytes(context.meta.size)})`;
		appendChatMessage(sender, `Shared a file:<br>${downloadLink}`);
		// Clean up
		delete receivedBuffers[sender];
	}




	function formatBytes(bytes, decimals = 2) {
		if (bytes === 0) return '0 Bytes';
		const k = 1024;
		const dm = decimals < 0 ? 0 : decimals;
		const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
		const i = Math.floor(Math.log(bytes) / Math.log(k));
		return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
	}
	

	return (
		<div className="app">
			<div className="sidebar">
				<div className="control-panel">
					<Button label={`${num} 화면공유`} onClick={startScreenShare} style={{ width: '100%' }} severity="success" />
				</div>

				<div className="participant-section">
					<h4>접속자목록</h4>

					{rows.length === 0 ? (
						<div>Waiting for connections...</div>
					) : (
						rows.map((row) => (
							<div key={row.cid} style={{marginTop:'2px', marginBottom:'2px'}}>
								<Button label={ `${row.cid} 연결` }onClick={() => connectToPeer(row.cid)} style={{ width: '100%' }}  severity='secondary' size="small"></Button>
							</div>
						))
					)}

				</div>

				<div className="chat-section">
					<div className="chat-header">
						<h4>파일전송</h4>
					</div>

					<div id="drop-zone" class="drop-zone-overlay">
						<div class="drop-message">📂 Drop files to share</div>
					</div>

					<div id="chat-messages">
						<div className="chat-placeholder"></div>
					</div>
				</div>
			</div>


			<div className="main-content">
				<div id="video-container">
					<video id="screen-preview" autoPlay playsInline></video>

					<button id="exit-fullscreen-btn" className="button" onClick={toggleFullScreen} style={{ display: "none" }}>
						❌ Exit Fullscreen
					</button>
				</div>

				<button className="fullscreen-btn button" onClick={toggleFullScreen}>
					⛶ Fullscreen
				</button>
			</div>
		</div>
	);
};

export default ShareView;
